import React, { useState, useRef  } from "react";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ThinkImageGallery = ({ images, folderName }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef(null);

  // Get subimages for a given imageId
  const getSubImages = (imageId) => images.filter(img => img.isSubimage && img.imageId === imageId);

  // Handle image selection
  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowVideo(false);
  };

  // Handle subimage selection
  const handleSubImageClick = (subImage) => {
    setSelectedImage(subImage);
    setShowVideo(false);
  };

  return (
    <div className="mt-4 bg-gray-600 mx-auto p-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 items-center justify-center">
        {images.filter(img => !img.isSubimage).map((image) => (
          <div key={image.imageId} className="cursor-pointer">
            <img
              src={`/api/downloads/${folderName}/${image.imageName}`}
              alt={image.imageTitle}
              className="w-full h-32 object-cover rounded-lg shadow-md hover:shadow-xl transition-transform hover:scale-105"
              onClick={() => handleImageClick(image)}
            />
            <p className="text-center text-sm font-medium mt-2">{image.imageTitle}</p>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex flex-col items-center justify-center p-6">
          <button
            className="absolute top-5 right-5 text-white text-2xl"
            onClick={() => setSelectedImage(null)}
          >
            ✖
          </button>

          {!showVideo ? (
            <div className="relative">
              {selectedImage.videoURL}
              <img
                src={`/api/downloads/${folderName}/${selectedImage.imageName}`}
                alt={selectedImage.imageTitle}
                className="max-w-lg rounded-lg shadow-xl"
              />
              {selectedImage.hasVideo && (
                <button
                  className="absolute bottom-3 right-3 bg-red-600 text-white p-3 rounded-full shadow-lg hover:bg-red-700 transition"
                  onClick={() => setShowVideo(true)}
                >
                  <FontAwesomeIcon icon={faPlay} />
                </button>
              )}
            </div>
          ) : (
            <video
              ref={videoRef}
              autoPlay
              controls
              width="100%"
              src={`/api/downloads/${folderName}/videos/${selectedImage.videoURL}.mp4`}
              style={{ display: 'block' }}
            />
            // <video
            //   src={selectedImage.videoURL}
            //   controls
            //   autoPlay
            //   className="max-w-lg rounded-lg shadow-xl"
            // />
          )}

          <p className="text-white text-lg mt-2">{selectedImage.imageTitle}</p>
          <p className="text-gray-300 text-sm">{selectedImage.imageDescription}</p>

          <div className="flex space-x-2 mt-4">
            {getSubImages(selectedImage.imageId).map((subImage) => (
              <img
                key={subImage.imageId}
                src={`/api/downloads/${folderName}/${subImage.imageName}`}
                alt={subImage.imageTitle}
                className="w-16 h-16 object-cover rounded-lg shadow-md cursor-pointer hover:scale-110 transition"
                onClick={() => handleSubImageClick(subImage)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThinkImageGallery;
